import {IMPERSONATION_QUERY_KEY, IMPERSONATION_TOKEN_KEY} from '@shared/constants/auth'
import {getImpersonationTargetBaseUrl} from '@shared-utils/auth/appUrls'

const KEY = IMPERSONATION_QUERY_KEY

export function setImpersonationUserToken(hash) {
  sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, hash)
}

export function getImpersonationUserToken() {
  return sessionStorage.getItem(IMPERSONATION_TOKEN_KEY)
}

export function clearImpersonationUserToken() {
  sessionStorage.removeItem(IMPERSONATION_TOKEN_KEY)
}

export function openImpersonationTab(token, origin) {
  const url = new URL(getImpersonationTargetBaseUrl(origin))
  url.searchParams.set(IMPERSONATION_QUERY_KEY, token)
  window.open(url.toString(), '_blank')
}

export function setImpersonationFromQueryToSession(query) {
  const value = query?.[KEY]
  const hash = Array.isArray(value) ? value[0] : value

  if (!hash) {
    return null
  }

  setImpersonationUserToken(hash)
  return hash
}
